var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "stretched policy-container" },
    [
      _c("div", { attrs: { id: "wrapper" } }, [
        _c(
          "div",
          {
            class:
              "container " +
              (_vm.$vuetify.breakpoint.xsOnly ? "pt-4 px-4 mb-2" : "pt-3 mb-6"),
          },
          [
            _c(
              "div",
              { staticClass: "d-inline-flex w-100 justify-content-start" },
              [
                _c(
                  "div",
                  { staticClass: "d-inline-flex w-50 align-items-center" },
                  [
                    _c(
                      "router-link",
                      { staticClass: "policy-back-link", attrs: { to: "/" } },
                      [
                        _c("img", {
                          attrs: {
                            src: "/content/svgs/arrow-back.svg",
                            alt: "back",
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "w-50 d-flex justify-content-end",
                    attrs: { id: "logo" },
                  },
                  [
                    _c("router-link", { attrs: { to: "/" } }, [
                      _c("img", {
                        staticClass: "logo-default",
                        attrs: {
                          srcset: "/content/images/stemdo-black-logo.png",
                          src: "/content/images/stemdo-black-logo.png",
                          alt: "Stemdo Logo",
                        },
                      }),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            class: _vm.$vuetify.breakpoint.xsOnly ? "px-3" : "",
            attrs: { id: "content" },
          },
          [
            _c("div", { staticClass: "content-wrap" }, [
              _c("div", { staticClass: "container policy-content" }, [
                _c(
                  "h1",
                  { staticClass: "ppmountent text-main-color policy-title" },
                  [_vm._v("Aviso Legal")]
                ),
                _vm._v(" "),
                _c("h2", [_vm._v("Introducción")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    '\n            El presente documento tiene como finalidad el establecer y regular las normas de uso del presente Sitio Web (en adelante el\n            "Sitio"), entendiendo por Sitio todas las páginas y sus contenidos propiedad de STEMDO ECOSYSTEM S.L., a las cuales se accede\n            a través de este dominio y sus subdominios.\n          '
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            La utilización del Sitio atribuye la condición de Usuario del mismo e implica la aceptación de todas las condiciones incluidas\n            en el presente Aviso Legal. El Usuario se compromete a leer atentamente el presente Aviso Legal en cada una de las ocasiones\n            en que se proponga utilizar el Sitio, ya que éste y sus condiciones de uso pueden sufrir modificaciones. Todos los avisos\n            pueden ser revisados en cualquier momento por el Usuario a través de nuestra página web.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Titularidad del Sitio")]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            STEMDO ECOSYSTEM S.L. forma parte del grupo STEMDO, integrado por distintas sociedades que operan bajo dicha denominación.\n            No obstante, la titularidad del presente Sitio corresponde exclusivamente a STEMDO ECOSYSTEM S.L.\n            Datos de Registro: Registro Mercantil de Huelva, Hoja H-27602, Tomo 1187, Folio 139.\n          "
                  ),
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("h2", [_vm._v("Propiedad intelectual e industrial")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Los derechos de propiedad intelectual de este Sitio, incluidos todos sus contenidos (textos, imágenes, diseño, código fuente,\n            marcas, nombres comerciales o signos distintivos), son titularidad de STEMDO ECOSYSTEM S.L., o de terceros de los que dispone\n            autorización cuando sea necesaria.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            La reproducción, distribución, comercialización o transformación, total o parcial, no autorizadas del contenido del Sitio,\n            constituye una infracción de los derechos de propiedad intelectual de STEMDO ECOSYSTEM S.L.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Todas las marcas o signos distintivos de cualquier clase contenidos en el Sitio están protegidos por Ley. El acceso y uso del\n            Sitio no implica la cesión de ningún derecho sobre los mismos. La utilización no autorizada de la información contenida en\n            este Sitio puede dar lugar al ejercicio de las acciones legales correspondientes.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Exclusión de responsabilidad")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            El contenido, programas, información y/o consejos expresados en este Sitio tienen carácter meramente informativo y no\n            constituyen asesoramiento profesional. STEMDO ECOSYSTEM S.L. no responde ni garantiza de ninguna forma la exactitud,\n            integridad o actualidad de los contenidos, quedando exenta de cualquier responsabilidad contractual o extracontractual con\n            los Usuarios que haga uso de ellos.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            En este Sitio se pueden publicar contenidos aportados por terceras personas o empresas. STEMDO ECOSYSTEM S.L. no responde\n            de la veracidad y exactitud de los mismos, quedando exenta de cualquier responsabilidad contractual o extracontractual con\n            los Usuarios que hagan uso de ellos.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            STEMDO ECOSYSTEM S.L. se reserva el derecho de modificar el contenido del Sitio sin previo aviso y sin ningún tipo de\n            limitación. Asimismo, declina cualquier responsabilidad por los eventuales daños y perjuicios que puedan ocasionarse por la\n            falta de disponibilidad y/o continuidad de este Sitio y de los servicios que se ofrecen en él.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            STEMDO ECOSYSTEM S.L. no garantiza la ausencia de virus ni de otros elementos en la web que puedan producir alteraciones en\n            su sistema informático, adoptando en todo momento las medidas razonables para evitar su presencia. STEMDO ECOSYSTEM S.L.\n            declina cualquier responsabilidad por los servicios que eventualmente pudieran prestarse en el Sitio por parte de terceros,\n            así como por los servicios y/o información que se preste en otros Sitios enlazados con este.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Los Usuarios que remitan cualquier tipo de información a STEMDO ECOSYSTEM S.L. se comprometen a que la misma sea veraz y que\n            no vulnere cualquier derecho de terceros ni la legalidad vigente. STEMDO ECOSYSTEM S.L. se reserva el derecho a retirar,\n            total o parcialmente, cualquier contenido o información del presente Sitio.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v('Política sobre hipervínculos o "links"')]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            En el Sitio podrán facilitarse hipervínculos o enlaces a otros contenidos. STEMDO ECOSYSTEM S.L. no será responsable de la\n            información a la que se redirigen los Usuarios siempre que: a) no tenga conocimiento efectivo de la ilicitud de la información;\n            y b) haya actuado con diligencia debida para suprimir o inutilizar el enlace correspondiente en caso de conocer dicha ilicitud.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            STEMDO ECOSYSTEM S.L. no asegura a los Usuarios que la información obtenida a través de dichos enlaces sea veraz y cumpla\n            con los requisitos legales aplicables. El Usuario asume por su cuenta y riesgo todo tipo de perjuicio que se le haya podido\n            generar por el acceso, uso y navegación del Sitio y del contenido al que se le haya redirigido.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Si un Usuario conoce que un enlace del Sitio puede redirigir a un contenido ilícito, deberá comunicarlo inmediatamente a\n            STEMDO ECOSYSTEM S.L. para proceder a su supresión. Queda estrictamente prohibida la colocación o facilitación de enlaces\n            a páginas webs cuyo contenido pueda ser ilícito o contrario a la moral, al orden público y a las normas sociales.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Tanto la reproducción como el uso de cualquier obra o contenido creado por STEMDO ECOSYSTEM S.L. en webs de terceros\n            requerirá de autorización previa y por escrito de STEMDO ECOSYSTEM S.L.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [
                  _vm._v("Condiciones de uso del portal para los Usuarios"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            El acceso al presente Sitio es gratuito salvo en lo relativo al coste de la conexión a través de la red de\n            telecomunicaciones suministrada por el proveedor de acceso contratado por los Usuarios.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v("Queda expresamente prohibido:"),
                ]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            En el caso de que el Usuario tuviera conocimiento de que los Sitios enlazados remiten a páginas cuyos contenidos o servicios\n            son ilícitos, nocivos, denigrantes, violentos o contrarios a la moral, le agradeceríamos que se pusiera en contacto con\n            STEMDO ECOSYSTEM S.L.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [
                  _vm._v("Política de protección de datos personales"),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "text-dark-grey-color" },
                  [
                    _vm._v(
                      "\n            STEMDO ECOSYSTEM S.L. como titular del Sitio cumple con el Reglamento (UE) 2016/679 del Parlamento y del Consejo de 27 de\n            abril de 2016 relativo a la protección de las personas físicas en lo que respecta al tratamiento de sus datos personales y la\n            libre circulación de éstos, así como con la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de\n            comercio electrónico. Si el Usuario desea obtener información más detallada sobre el tratamiento de sus datos, consulte nuestra\n            "
                    ),
                    _c("router-link", { attrs: { to: "/privacy" } }, [
                      _vm._v("Política de Privacidad"),
                    ]),
                    _vm._v(".\n          "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h2", [_vm._v("Cookies")]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "text-dark-grey-color" },
                  [
                    _vm._v(
                      "\n            Las cookies sirven para mejorar el funcionamiento de la web. Este Sitio utiliza cookies propias y de terceros con la finalidad\n            de mejorar la experiencia de navegación del Usuario y analizar hábitos de uso para optimizar los contenidos y servicios\n            ofrecidos. El Usuario puede consultar información detallada sobre el uso de cookies en nuestra\n            "
                    ),
                    _c("router-link", { attrs: { to: "/cookies" } }, [
                      _vm._v("Política de Cookies"),
                    ]),
                    _vm._v(".\n          "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h2", [
                  _vm._v("Uso de software, herramientas y contenidos técnicos"),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "text-dark-grey-color" },
                  [
                    _vm._v(
                      "\n            El Usuario se compromete a hacer un uso correcto del Sitio y del contenido incluido en el mismo, así como de los servicios\n            que adquiera, de conformidad con las leyes aplicables, las presentes condiciones, la\n            "
                    ),
                    _c("router-link", { attrs: { to: "/privacy" } }, [
                      _vm._v("Política de Privacidad"),
                    ]),
                    _vm._v(" y la\n            "),
                    _c("router-link", { attrs: { to: "/cookies" } }, [
                      _vm._v("Política de Cookies"),
                    ]),
                    _vm._v(
                      ", así como con la buena fe, las buenas costumbres y el orden\n            público. STEMDO ECOSYSTEM S.L. perseguirá el incumplimiento de las presentes condiciones ejerciendo todas las acciones\n            civiles y penales que le correspondan en derecho.\n          "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            El Usuario responderá por los daños y perjuicios causados a STEMDO ECOSYSTEM S.L. y/o a terceros por:\n          "
                  ),
                ]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            En caso de resultar necesaria la creación de un usuario y contraseña para el acceso a los productos o servicios ofrecidos por\n            STEMDO ECOSYSTEM S.L., el Usuario es el único responsable de establecer las medidas de seguridad necesarias para evitar el\n            uso no autorizado de dicha información. Asimismo, se comprometerá a no ceder el usuario y la contraseña a terceros, ni a\n            permitir el acceso al contenido y a los servicios que requieran de tales credenciales.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            El Usuario se obliga a comunicar a STEMDO ECOSYSTEM S.L. cualquier evento que pueda producir un uso indebido de su cuenta,\n            como robo, pérdida o accesos no autorizados. Mientras no comunique tales eventos, STEMDO ECOSYSTEM S.L. quedará exento de\n            cualquier responsabilidad que pudiera surgir del uso indebido de su contraseña.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Salvo que se indique expresamente lo contrario, el acceso a dichos recursos no implica la concesión de licencia o derecho de\n            uso alguno sobre los mismos, quedando prohibida su reproducción, distribución, modificación, ingeniería inversa o explotación\n            por cualquier medio sin la autorización previa y expresa de STEMDO ECOSYSTEM S.L. o de los titulares correspondientes.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Legislación y resolución de disputas")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            STEMDO ECOSYSTEM S.L. informa que el presente Aviso Legal se rige en todos y cada uno de sus extremos por la legislación\n            española y la resolución de cualquier posible controversia quedará sometida a los juzgados y tribunales de la ciudad de\n            Huelva, a menos que el Usuario actúe como consumidor, en cuyo caso la competencia recaerá en los Juzgados y Tribunales\n            correspondientes al domicilio del consumidor.\n          "
                  ),
                ]),
                _vm._v(" "),
                _vm._m(4),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "El presente contrato está establecido en idioma español."
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("footer", { attrs: { id: "footer" } }, [
          _c("div", { attrs: { id: "copyrights" } }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(5),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-7 text-center copyright-links" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-around px-2" },
                      [
                        _c("router-link", { attrs: { to: "/privacy" } }, [
                          _c("u", [_vm._v("Política de privacidad")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/cookies" } }, [
                          _c("u", [_vm._v("Política de Cookies")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/legal" } }, [
                          _c("u", [_vm._v("Aviso Legal")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/contact" } }, [
                          _c("u", [_vm._v("Contacto")]),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._m(6),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("SCookieBanner"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-dark-grey-color" }, [
      _vm._v("\n            El titular del presente Sitio es "),
      _c("strong", [_vm._v("STEMDO ECOSYSTEM S.L.")]),
      _vm._v(
        ", con domicilio en Calle de la Villa de Madrid 17 -\n            Despacho 15, 21001 Huelva, y con CIF: B10862423.\n          "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-dark-grey-color" }, [
      _vm._v(
        "\n            El Usuario puede ponerse en contacto con nosotros en:\n            "
      ),
      _c("strong", [_vm._v("Tfno:")]),
      _vm._v(" 959469471 —\n            "),
      _c("strong", [_vm._v("e-mail:")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "mailto:dpd@stemdo.io" } }, [
        _vm._v("dpd@stemdo.io"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", { staticClass: "text-dark-grey-color" }, [
      _c("li", [
        _vm._v(
          "El uso del Sitio con fines lesivos para los bienes o intereses de STEMDO ECOSYSTEM S.L. o de terceros."
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Cualquier uso que pueda sobrecargar, dañar o inutilizar las redes, servidores o aplicaciones informáticas de STEMDO ECOSYSTEM S.L. o de terceros."
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "El uso del Sitio para fines ilícitos o contrarios a la buena fe, al orden público o a los intereses de STEMDO ECOSYSTEM S.L. o de terceros."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", { staticClass: "text-dark-grey-color" }, [
      _c("li", [
        _vm._v(
          "La difusión en la red de un virus informático o cualquier otro sistema que pueda provocar daños a los sistemas físicos o lógicos de STEMDO ECOSYSTEM S.L. y de sus proveedores."
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Actos de explotación no permitidos por el autor de los derechos de propiedad intelectual e industrial."
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "La supresión de los elementos de seguridad (como marcas de agua, logotipos…) que STEMDO ECOSYSTEM S.L. haya incorporado en el contenido para identificar su autoría."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-dark-grey-color" }, [
      _vm._v(
        "\n            Asimismo, las partes tienen la opción de someter sus disputas a los procesos de arbitraje contemplados en la legislación de\n            arbitraje y de protección de los consumidores y Usuarios, así como a los procedimientos de resolución extrajudicial de\n            conflictos. En este contexto, la Comisión Europea pone a disposición una plataforma en línea para la resolución de litigios,\n            accesible a través del siguiente enlace:\n            "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://consumer-redress.ec.europa.eu/index_es",
            target: "_blank",
          },
        },
        [_vm._v("https://consumer-redress.ec.europa.eu/index_es")]
      ),
      _vm._v(".\n          "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "col-md-3 text-center text-md-start",
        staticStyle: { color: "#606061" },
      },
      [_c("b", [_vm._v("Stemdo © 2024")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "col-md-2 text-center text-md-end pb-4 pb-sm-0" },
      [
        _c("div", { staticClass: "d-flex justify-content-around" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.instagram.com/stemdo_io/?hl=es",
                target: "_blank",
              },
            },
            [
              _c("img", {
                staticClass: "logo-default",
                attrs: {
                  src: "/content/images/instagram-icon.png",
                  alt: "Instagram icon",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.linkedin.com/company/stemdo/",
                target: "_blank",
              },
            },
            [
              _c("img", {
                staticClass: "logo-default",
                attrs: {
                  src: "/content/images/linkedin-icon.png",
                  alt: "Linkedin icon",
                },
              }),
            ]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }